import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, of, throwError } from 'rxjs';
import { DOCUMENT } from '@angular/common';

// const API_URL = 'https://api.actividadesencanfranc.hub2b.aititubi.es'
import { environment } from '../../../environments/environment';
// const API_URL = 'https://api.actividadesencanfranc.hub2b.travel'
const GEANT_URL = environment.geantEnv + '/hub2b/tour2b'

@Injectable({
    providedIn: 'root'
})
export class MainService {

    constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) { }

    public isAuthenticated(): boolean {
        return this.getCookie('auth') ? true : false;
    }

    private getCookie(name: string): string | null {
        const match = this.document.cookie.match(
            new RegExp(`(^| )${name}=([^;]+)`)
        );
        return match ? match[2] : null;
    }

    public getAll(API_URL: string, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public get(API_URL: string, id: any, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}/${id}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getFirst(API_URL: string, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            map((response: any) => {
                // Assuming the response is an array and we want the first item
                return response
            }),
            catchError(this.handleError)
        );
    }
    public getConnection(connection: string, externalChannel: string, endpoint: string, id: any, language: any, externalSupplierCode?: any): Observable<any> {
        const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
        // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
        // helpers comunes
        const BASE = environment.geantEnv;

        const getLocale = (lang?: string) =>
            (lang && lang.includes("-")) ? lang : `${(lang || "es")}-${(lang || "es").toUpperCase()}`;

        const getHeaders = (lang?: string) => ({
            Authorization: authHeader,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-Language": getLocale(lang)
        });

        // por si lo necesitas en más sitios
        const withTz = (d: Date) => {
            const copy = new Date(d);
            copy.setMinutes(copy.getMinutes() - copy.getTimezoneOffset());
            return copy;
        };

        if (connection === "geant") {
            // 1) sessions-filtered  (GET)
            if (endpoint === "sessions-filtered") {
                const start = withTz(id.start).toISOString().split("T")[0];
                const end = withTz(id.end).toISOString().split("T")[0];

                const qs = new URLSearchParams({
                    "from-date": start,
                    "to-date": end,
                    externalSupplierCode,
                    modalityId: String(id.modalityId)
                });

                const url = `${BASE}/${externalChannel}/tour2b/1/activities/${encodeURIComponent(id.productId)}/${endpoint}?${qs.toString()}`;

                return this.http.get(url, { headers: getHeaders(language) }).pipe(
                    catchError(error => error.status === 404 ? of([]) : this.handleError(error))
                );
            }

            // 2) pickups por canal (GET)
            if (endpoint === "pickups") {
                const PICKUP_ROUTES: Record<string, (code: string) => string> = {
                    musement_pull: (code) =>
                        `${BASE}/musement_pull/tour2b/1/activities/${encodeURIComponent(code)}/pickups`,
                    lowcosttours_pull: (code) =>
                        `${BASE}/lowcosttours_pull/tour2b/1/product-pickups?${new URLSearchParams({ productId: code }).toString()}`
                };

                const buildUrl = PICKUP_ROUTES[externalChannel];
                if (!buildUrl) {
                    // si entra un canal no soportado, devolvemos lista vacía elegante
                    return of([]);
                }

                const url = buildUrl(externalSupplierCode);
                return this.http.get(url, { headers: getHeaders(language) }).pipe(
                    catchError(error => error.status === 404 ? of([]) : this.handleError(error))
                );
            }

            // 3) paxdetails (POST)
            if (endpoint === "paxdetails") {
                const url = `${BASE}/vernium/geant/1/paxdetails`;
                return this.http.post(url, id, { headers: getHeaders(language) }).pipe(
                    catchError(error => error.status === 404 ? of([]) : this.handleError(error))
                );
            }

            // 3.1) check real availability (GET)
            if (endpoint === "check-availability-and-rates") {
                const url = `${BASE}/${externalChannel}/tour2b/1/activities/sessions/${id.id}/check-availability-and-rates`;
                // const url = `${BASE}/vernium/geant/1/paxdetails`;
                return this.http.get(url, { headers: getHeaders(language) }).pipe(
                    catchError(error => error.status === 404 ? of([]) : this.handleError(error))
                );
            }

            // 4) default: availabilities (POST)
            const body = {
                "from-date": id.date,
                "to-date": id.date,
                isWidget: true,
                channelKey: externalChannel,
                externalId: id.productId || externalSupplierCode,
                pickup: id?.pickup?.id ?? null,
                isOpenDate: !!id?.isOpenDate,
                id: id?.hubId ?? null
            };

            return this.http.post(`${BASE}/vernium/geant/1/availabilities`, body, {
                headers: getHeaders(language)
            }).pipe(
                catchError(error => error.status === 404 ? of([]) : this.handleError(error))
            );
        }

        // return this.http.get(`https://api.tour2b.hub2b.aititubi.es/${endpoint}/${id}`, {
        // return this.http.get(`https://geant.hub2b.travelhub2b/tour2b/${endpoint}/${id}`, {
        return this.http.get(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}/${id}`, {
            headers: {
                'Accept-Language': language
            }
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getConnectionTransfers(connection: string, externalChannel: string, endpoint: string, data: any): Observable<any> {
        const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
        // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);

        // return this.http.post(`https://geant.hub2b.travel${connection}/geant/1/${endpoint}`, data.body, {
        return this.http.get(`${environment.geantEnv}/${externalChannel}/geant/1/${endpoint}`, {
            headers: {
                'Authorization': authHeader,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).pipe(
            catchError(error => {
                if (error.status === 404) {
                    return of([]);
                }
                return this.handleError(error);
            })
        );
    }

    public postConnectionTransfers(connector: string, externalChannel: string, endpoint: string, data: any): Observable<any> {

        if (connector == "geant") {
            const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
            // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
            // return this.http.post(`https://geant.hub2b.travel${externalChannel}/tour2b/1/${endpoint}`, data, {
            return this.http.post(`${environment.geantEnv}/${externalChannel}/geant/1/${endpoint}`, data, {
                headers: {
                    'Authorization': authHeader,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).pipe(
                catchError(this.handleError)
            );
        }

        // return this.http.post(`https://api.${externalChannel}.hub2b.aititubi.es/${endpoint}`, data, {
        return this.http.post(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}`, data, {
            headers: {
                // 'Authorization': authHeader,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getConnectionEndpoint(externalChannel: string, endpoint: string, language: any): Observable<any> {
        const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
        // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
        return this.http.get(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}`, {
            headers: {
                'Accept-Language': language
            }
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getByName(API_URL: string, webName: any, name: any, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}?name=${name}&web.name=${webName}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getBySlug(API_URL: string, slug: any, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}/${slug}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getByParameter(API_URL: string, parameter: string, value: string, endpoint: string, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}?${parameter}=${value}`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public format_date(date: string) {
        const [month, day, year] = date.split('/').map(Number);
        const formattedDate = new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0];

        return formattedDate
    }

    // public getActivityAvailabilities(externalChannel: string, endpoint: string, currentDate: any, activity: any): Observable<any> {
    public getActivityAvailabilities(connector: string, externalChannel: string, endpoint: string, currentDate: any, endDate: any, activity: any, pickup: any): Observable<any> {
        const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
        // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
        if (connector == "geant") {
            const today = new Date();

            let startDateFormated = new Date(currentDate);
            const endDateFormated = new Date(endDate);

            // Si la fecha de inicio es menor que hoy, usamos hoy
            if (new Date(startDateFormated) < today) {
                startDateFormated = today;
            }
            const y = startDateFormated.getFullYear();
            const m = String(startDateFormated.getMonth() + 1).padStart(2, '0');
            const d = String(startDateFormated.getDate()).padStart(2, '0');
            const fromDate = `${y}-${m}-${d}`;

            const y2 = endDateFormated.getFullYear();
            const m2 = String(endDateFormated.getMonth() + 1).padStart(2, '0');
            const d2 = String(endDateFormated.getDate()).padStart(2, '0');
            const toDate = `${y2}-${m2}-${d2}`;

            let body = {
                // "modalityId": 789, //not necessary in this case
                "from-date": fromDate,
                "to-date": endDate ? toDate : null,
                "isWidget": true,
                "channelKey": externalChannel,
                "externalId": activity,
                "pickup": pickup && pickup.id ? pickup.id : null,
                "isRange": true
            }

            return this.http.post(`${environment.geantEnv}/vernium/geant/1/availabilities`, body, {
                headers: {
                    'Authorization': authHeader,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).pipe(
                catchError(error => {
                    if (error.status === 404) {
                        return of([]);
                    }
                    return this.handleError(error);
                })
            );
        } else {
            // return this.http.get(`https://geant.hub2b.aititubi.eshub2b/tour2b/${endpoint}/all?date[after]=${'03-09-2024'}&activitySchedule.activitySeason.activityFee.activity=${activity}&quota[gte]=1&isAvailable=true&order[activitySchedule.startTime]`, {
            // return this.http.get(`https://api.tour2b.hub2b.aititubi.es/${endpoint}?date[after]=${currentDate.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$2-$1-$3')}&date[before]=${endDate.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$2-$1-$3')}&activitySchedule.activitySeason.activityFee.activity=${activity}&quota[gt]=0&isAvailable=true&order[activitySchedule.date]`, {
            return this.http.get(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}?date[after]=${currentDate.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$2-$1-$3')}&date[before]=${endDate.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/, '$2-$1-$3')}&activitySchedule.activitySeason.activityFee.activity=${activity}&quota[gt]=0&isAvailable=true&order[activitySchedule.date]`, {
                headers: {
                    'Authorization': authHeader,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).pipe(
                catchError(this.handleError)
            );
        }
    }

    public getAllActivitiesAvailabilities(API_URL: string, endpoint: string, checkIn: any, checkOut: any, location: any, persons: any): Observable<any> {
        // return this.http.get(`${API_URL}/${endpoint}?date[after]=${checkIn}&date[before]=${checkOut}${location.includes('Toda') ? (location == 'Todas' ? '' : '&activitySchedule.activitySeason.activityFee.activity.location.name=' + location.replace('Toda ', '')) : '&activitySchedule.activitySeason.activityFee.activity.zones.name=' + location}&activitySchedule.activitySeason.activityFee.activity.isActive=true&quota[gte]=${persons}&isAvailable=true`).pipe(
        // return this.http.get(`${API_URL}/${endpoint}?date[after]=${checkIn}&date[before]=${checkOut}&activitySchedule.activitySeason.activityFee.activity.isActive=true&quota[gte]=${persons}&isAvailable=true`).pipe(
        return this.http.get(`${API_URL}/${endpoint}?date[after]=${checkIn}&date[before]=${checkOut}${location ? '&location.slug=' + location : ''}&activitySchedule.activitySeason.activityFee.activity.isActive=true&isAvailable=true`).pipe(
            catchError(this.handleError)
        );
    }

    public getAllIntegrationActivitiesAvailabilities(endpoint: string, checkIn: any, checkOut: any, location: any, persons: any): Observable<any> {
        const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
        // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
        return this.http.get(`${GEANT_URL}/${endpoint}/all?date[after]=${checkIn}&date[before]=${checkOut}${location.includes('Toda') ? (location == 'Todas' ? '' : '&activitySchedule.activitySeason.activityFee.activity.location.name=' + location.replace('Toda ', '')) : '&activitySchedule.activitySeason.activityFee.activity.zones.name=' + location}&activitySchedule.activitySeason.activityFee.activity.isActive=true&quota[gte]=${persons}&isAvailable=true`, {
            headers: {
                'Authorization': authHeader,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getIntegrationActivities(API_URL: string, endpoint: string, location: any, language: any): Observable<any> {
        // return this.http.get(`${API_URL}/${endpoint}?exists[channelActivities]=true${location.includes('Toda') ? (location == 'Todas' ? '' : '&location.name=' + location.replace('Toda ', '')) : '&zones.name=' + location}&isActive=true`).pipe(
        return this.http.get(`${API_URL}/${endpoint}?exists[channelActivities]=true${location ? '&location.slug=' + location : ''}&isActive=true`, {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getIntegrationAvailabilities(externalChannel: any, endpoint: string, ids: any, checkIn: any, checkOut: any, persons: any): Observable<any> {
        // return this.http.get(`https://api.venntur.hub2b.travel/${endpoint}?` + ids.map((id: any) => `activitySchedule.activitySeason.activityFee.activity.id[]=${id}`).join('&') + `&date[after]=${checkIn}&date[before]=${checkOut}&activitySchedule.activitySeason.activityFee.activity.isActive=true&quota[gte]=${persons}&isAvailable=true`).pipe(
        return this.http.get(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}?` + ids.map((id: any) => `activitySchedule.activitySeason.activityFee.activity[]=${id}`).join('&') + `&date[after]=${checkIn}&date[before]=${checkOut}&activitySchedule.activitySeason.activityFee.activity.isActive=true&isAvailable=true`).pipe(
            // return this.http.get(`https://api.api.${externalChannel}.hub2b.travel.hub2b.travel/${endpoint}?` + ids.map((id: any) => `activitySchedule.activitySeason.activityFee.activity[]=${id}`).join('&') + `&date[after]=${checkIn}&date[before]=${checkOut}&activitySchedule.activitySeason.activityFee.activity.isActive=true&isAvailable=true`).pipe(
            catchError(this.handleError)
        );
    }

    public getFilterIntegratedActivities(API_URL: string, endpoint: string, ids: any, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}?isActive=true&` + ids.map((id: any) => `channelActivities.code[]=${id}`).join('&'), {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    public getFilterActivities(API_URL: string, endpoint: string, ids: any, language: any): Observable<any> {
        return this.http.get(`${API_URL}/${endpoint}?isActive=true&` + ids.map((id: any) => `id[]=${id}`).join('&'), {
            headers: {
                'Accept-Language': language,
            },
        }).pipe(
            catchError(this.handleError)
        );
    }

    // public getFilterIntegrationActivities(externalChannel: string, endpoint: string, ids: any): Observable<any> {
    // const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
    //     // return this.http.get(`https://api.${externalChannel}.hub2b.aititubi.es/${endpoint}?` + ids.map((id: any) => `id[]=${id}`).join('&'), {
    //     return this.http.get(`https://api.tour2b.hub2b.travel/${endpoint}?` + ids.map((id: any) => `id[]=${id}`).join('&'), {
    //         headers: {
    //             'Authorization': authHeader,
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json'
    //         }
    //     }).pipe(
    //         catchError(this.handleError)
    //     );
    // }

    public post(API_URL: string, endpoint: string, data: any): Observable<any> {
        return this.http.post(`${API_URL}/${endpoint}`, data).pipe(
            catchError(this.handleError)
        );
    }

    public postConnection(connector: string, externalChannel: string, endpoint: string, data: any): Observable<any> {

        if (connector == "geant") {
            const authHeader = 'Basic ' + btoa(`${'mst_user'}:${'mst_password'}`);
            // const authHeader = 'Basic ' + btoa(`${'test'}:${'noquiero'}`);
            return this.http.post(`${environment.geantEnv}/${externalChannel}/tour2b/1/${endpoint}`, data, {
                // return this.http.post(`https://geant.hub2b.travel/vernium/geant/1/prebook`, data, {
                // return this.http.post(`https://geant.hub2b.travel/suntransfers_pull/geant/1/bookings`, data, {
                headers: {
                    'Authorization': authHeader,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).pipe(
                catchError(this.handleError)
            );
        }

        // return this.http.post(`https://api.${externalChannel}.hub2b.aititubi.es/${endpoint}`, data, {
        return this.http.post(`https://api.${externalChannel}${environment.hub2bEnv}/${endpoint}`, data, {
            headers: {
                // 'Authorization': authHeader,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).pipe(
            catchError(this.handleError)
        );
    }

    public sendEmail(API_URL: string, data: any) {
        return this.http.post(`${API_URL}/send/email`, data).pipe(
            catchError(this.handleError)
        );
    }

    // BehaviorSubject to hold the data and emit updates
    private dataSubject = new BehaviorSubject<any>(null);
    // Observable to allow components to subscribe to data changes
    data$ = this.dataSubject.asObservable();
    // Method to update data from dialog
    sendData(data: any) {
        this.dataSubject.next(data);
    }

    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('Ha ocurrido un error:', error.error.message);
        } else {
            console.error(
                `Backend devolvió el codigo ${error.status}, ` +
                `Contenido: ${JSON.stringify(error.error)}`);
        }
        return throwError(() => error);
    };

}